export function setActivatorAttributes(activator, { id, active = false, ariaHaspopup, activatorDisabled = false, }) {
    if (!activatorDisabled) {
        activator.tabIndex = activator.tabIndex || 0;
    }
    activator.setAttribute('aria-controls', id);
    activator.setAttribute('aria-owns', id);
    activator.setAttribute('aria-expanded', String(active));
    if (ariaHaspopup != null) {
        activator.setAttribute('aria-haspopup', String(ariaHaspopup));
    }
}
export function isInPortal(element) {
    let { parentElement } = element;
    while (parentElement) {
        if (parentElement.matches('[data-portal-id]'))
            return false;
        parentElement = parentElement.parentElement;
    }
    return true;
}
//# sourceMappingURL=utils.activator.js.map